import { SchoolFeature } from 'enums';

// Plain module state rather than Redux so axios-config can record a server-side lock without importing the store.
let lockedFeatures: ReadonlySet<SchoolFeature> = new Set();
const listeners = new Set<() => void>();

const emitChange = () => listeners.forEach((listener) => listener());

export const getLockedSchoolFeatures = () => lockedFeatures;

export const setLockedSchoolFeatures = (features: SchoolFeature[]) => {
  lockedFeatures = new Set(features);
  emitChange();
};

/** A 403 SCHOOL_FEATURE_LOCKED means the school locked it since the policy was loaded. */
export const markSchoolFeatureLocked = (feature: SchoolFeature) => {
  if (lockedFeatures.has(feature)) return;
  lockedFeatures = new Set([...lockedFeatures, feature]);
  emitChange();
};

export const subscribeToSchoolFeaturePolicy = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
